define(["underscore","backbone"],
    function(_, Backbone) {
        var Quote = Backbone.Model.extend({
            idAttribute: 'promotion',
            urlRoot: "/rest_quotes_feeder/quotes/",
            url: "/rest_quotes_feeder/quotes/"
        });

        return Quote;
    });



//////////////////
// WEBPACK FOOTER
// ./assets/common/main/js/models/quote_model.js
// module id = 30
// module chunks = 0